<template>
  <ExternalTwitterEmbed
    v-if="!tweetError"
    :tweet-url="getSrc()"
    cards="visible"
    conversation="all"
    lang="en"
    theme="light"
    align="center"
    :width="400"
    :dnt="false"
    @tweet-load-error="onTweetLoadError"
    @tweet-load-success="onTweetLoadSuccess"
  >
    <template v-slot:loading>
    </template>

    <template v-slot:error>
    </template>
  </ExternalTwitterEmbed>
</template>

<script setup lang="ts">

const {payload} = defineProps < {
  payload? : any
} > ()

const getSrc = () => {
  return payload.attributes.src
}

const tweetError = ref<Error | null>(null);
function onTweetLoadError(error: Error) {
  tweetError.value = error;
}
</script>
